export default __webpack_public_path__ + "static/media/image_HitConfigure.e90fbcde.svg";